import React from 'react';

// Stat tile shared by the owner console panels and the Revenue dashboard.
// Label + headline value + one-line sub, ink stays in text tokens; the accent
// colour only tints the icon chip and the number.
export default function KpiTile({ label, value, sub, icon: Icon, color, testid }) {
  const accent = color || '#070B5F';
  return (
    <div className="bg-white rounded-2xl p-5 border border-slate-100 shadow-sm" data-testid={testid}>
      <div className="flex items-start justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-widest font-bold text-slate-500">{label}</div>
          <div className="font-serif text-3xl font-bold mt-1" style={{ color: accent }}>{value}</div>
          {sub && <div className="text-[11px] text-slate-500 mt-0.5">{sub}</div>}
        </div>
        {Icon && (
          <div className="p-2 rounded-lg" style={{ background: accent + '15', color: accent }}>
            <Icon size={18} />
          </div>
        )}
      </div>
    </div>
  );
}
